export default __webpack_public_path__ + "static/media/fa-regular-400.06b9d19c.svg";